import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/Home";
import AddAudit from "./pages/CrypticPage";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./component/ProtectedRoute";
import NoPage from "./pages/NoPage"; // <-- import the 404 page

function App() {
  const { REACT_APP_BASE_URL = "/latest-news" } = process.env;

  return (
    <BrowserRouter basename={REACT_APP_BASE_URL}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/records"
          element={
            <ProtectedRoute>
              <AddAudit />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
